<!-- File: NavItems.vue -->
<template>
    <ul class="navigation"> 
        <li><router-link to="/">Beranda</router-link></li>
        <li><router-link to="/Berita">Berita</router-link></li>

        <li class="menu-item-has-children">
            <a href="#">Profil</a>
            <ul class="sub-menu">
                <li><router-link to="/data_pegawai">Data Pegawai</router-link></li>
                <li><router-link to="/tentang">Tentang / Sejarah BKAD</router-link></li>
                <li><router-link to="/tugas_pokok">Tugas Pokok</router-link></li>
                <li><router-link to="/struktur_organisasi">Struktur Organisasi</router-link></li>
                <li><router-link to="/visi_misi">Visi Misi</router-link></li> 
            </ul>
        </li>
        <li class="menu-item-has-children">
            <a href="#">Unit Kerja</a>
            <ul class="sub-menu" >
                <li><router-link to="/sekretariat">Sekretariat</router-link></li>
                <li><router-link to="/bid_akutansi">Bidang Akutansi</router-link></li>
                <li><router-link to="/bid_anggaran">Bidang Anggaran</router-link></li>
                <li><router-link to="/bid_aset">Bidang Aset</router-link></li>
                <li><router-link to="/bid_bud">Bidang BUD</router-link></li> 
            </ul>
        </li> 

        <li class="menu-item-has-children">
            <a href="#">Peraturan</a>
            <ul class="sub-menu" >
                <li><router-link to="/perpres">Peraturan Presiden</router-link></li>
                <li><router-link to="/permen">Peraturan Mentri</router-link></li>
                <li><router-link to="/perbup">Peraturan Bupati</router-link></li>
                <li><router-link to="/perda">Peraturan Daerah</router-link></li> 
            </ul>
        </li>
        <li class="menu-item-has-children">
            <a href="#">Data & Dokumen</a>
            <ul class="sub-menu" >
                <li><router-link to="/pengelolaan_hbo">Pengolahan Hibah Dan Bansos</router-link></li>
                <li><router-link to="/sop">Standar Operasional Prosedur</router-link></li>
                <li><router-link to="/transparansi_anggaran">Transparansi Anggaran Daerah</router-link></li>
                <li><router-link to="/dokumen_opd">Dokumen Lainnya</router-link></li> 
                    
            </ul>
        </li>

            

        <li class="menu-item-has-children">
            <a href="#">Galeri</a>
            <ul class="sub-menu">
                <li><router-link to="/gallery_foto">Foto</router-link></li>
                <li><router-link to="/gallery_video">Video</router-link></li> 
            </ul>
        </li>

        <li class="menu-item-has-children">
        <a href="#">Sipola - Konsel</a>
            <ul class="sub-menu">
                <li class="menu-item-has-children">
                    <a href="#">Realisasi Belanja OPD</a>
                    <ul class="sub-menu">
                        <li><router-link to="/realisasi_anggaran_2024">2024</router-link></li> 
                        <li><router-link to="/realisasi_anggaran_2025">2025</router-link></li>  
                        <li><router-link to="/realisasi_anggaran_2026">2026</router-link></li>  
                    </ul>
                </li>
                <li class="menu-item-has-children">
                    <a href="#">Realisasi PAD</a>
                    <ul class="sub-menu">
                        <li><router-link to="/realisasi_pad_2024">2024</router-link></li> 
                        <li><router-link to="/realisasi_pad_2025">2025</router-link></li>  
                        <li><router-link to="/realisasi_pad_2026">2026</router-link></li>  
                    </ul>
                </li>  
            </ul>
        </li>

    </ul>
</template>